import { marineTentaclePath, type MarinePhysicsModel } from "./marinePhysics";

interface MarinePhysicsLayerProps {
  model: MarinePhysicsModel;
}

const VIEWBOXES = {
  jellyfish: { width: 96, height: 128, centerX: 48, centerY: 0 },
  fish: { width: 90, height: 64, centerX: 45, centerY: 0 },
  starfish: { width: 80, height: 80, centerX: 40, centerY: 0 },
  turtle: { width: 120, height: 80, centerX: 60, centerY: 0 },
} as const;

export default function MarinePhysicsLayer({ model }: MarinePhysicsLayerProps) {
  const viewBox = VIEWBOXES[model.config.character];
  const offset = { x: -viewBox.centerX, y: -viewBox.centerY };
  return (
    <svg
      className="marinePhysicsLayer"
      viewBox={`0 0 ${viewBox.width} ${viewBox.height}`}
      aria-hidden="true"
      focusable="false"
    >
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={model.config.character === "jellyfish" ? 2 : 1.4} opacity={model.config.character === "jellyfish" ? 0.82 : 0.58}>
        {model.chains.map((chain, index) => (
          <path key={`${model.config.character}-${index}`} d={marineTentaclePath(chain, offset)} />
        ))}
      </g>
    </svg>
  );
}
